module.exports = __webpack_public_path__ + "img/angle_240.54aa895b.jpg";